import React from 'react'
import styled from 'styled-components'

const ContainerItem = styled.div<{ active: boolean }>`
  background: ${p => p.active ? p.theme.palette.secondary.main : p.theme.palette.text.grayLight};
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  z-index: 2;
  padding: 8px 12px;
  cursor: pointer;
  padding-left: 20px;
  padding-right: 20px;

  > p {
    color: white;
    margin: 0;
  }

  > svg {
    width: 18px;
    color: ${p => p.theme.palette.primary.main}
  }
`

interface IOwnProps{
  icon: React.ReactElement;
  text: string;
  active?: boolean;
  onClick: () => void;
}

const StepperItem: React.FunctionComponent<IOwnProps> = ({ icon, text, active = false, onClick }) => {
  return (
    <ContainerItem active={active} onClick={onClick}>
      {icon}
      <p>{text}</p>
    </ContainerItem>
  )
}

export default StepperItem